import { Users } from 'lucide-react'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { useAudiences } from '@/api/hooks/use-audiences'
import { AudienceCard } from '@/pages/audiences/audience-card'
import { AudienceCreateModal } from '@/pages/audiences/audience-create-modal'

export function AudiencesListPage(): React.JSX.Element {
  const [showCreate, setShowCreate] = useState(false)
  const navigate = useNavigate()
  const { data, isLoading } = useAudiences()

  const audiences = data?.data ?? []

  if (isLoading) {
    return <div className="py-12 text-center text-text-tertiary">Loading audiences...</div>
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-text-primary">Audiences</h1>
        <button
          type="button"
          onClick={() => setShowCreate(true)}
          className="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
        >
          + New Audience
        </button>
      </div>

      {audiences.length === 0 ? (
        <EmptyAudiences onCreateClick={() => setShowCreate(true)} />
      ) : (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {audiences.map((audience) => (
            <AudienceCard key={audience.id} audience={audience} />
          ))}
        </div>
      )}

      <AudienceCreateModal
        open={showCreate}
        onClose={() => setShowCreate(false)}
        onCreated={(id) => navigate(`/audiences/${id}`)}
      />
    </div>
  )
}

function EmptyAudiences({ onCreateClick }: { onCreateClick: () => void }): React.JSX.Element {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <Users className="mb-4 h-12 w-12 text-text-tertiary" />
      <h3 className="text-lg font-medium text-text-primary">No audiences yet</h3>
      <p className="mt-1 max-w-sm text-sm text-text-secondary">
        Create your first audience to start managing subscribers and sending campaigns.
      </p>
      <button
        type="button"
        onClick={onCreateClick}
        className="mt-4 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
      >
        Create your first audience
      </button>
    </div>
  )
}
